import customGroupsService from '../../services/customGroupsService';

export default function isCustomGroup(locOrGroupCode) {
  return !!customGroupsService.urlUtils.parseUrlParam(locOrGroupCode);
}
